// import React from 'react';
import React, {useEffect, useMemo, useRef, useState} from "react";
import '../../styles/style.css';
import Calendar from "./Availability";
import { FaUsers, FaBed, FaBath } from "react-icons/fa";
import {useParams} from "react-router-dom";
import axios from "axios";
import BASE from "../../config";
import stripHTMLTags, { getCurrencySymbol, getPropertyCurrencySymbol } from "../../functions";
import ReCAPTCHA from "react-google-recaptcha";
import {addMonths, differenceInDays, format} from "date-fns";

const parseExtraAmount = (value) => {
  if (value == null || value === "") return null;
  const amount = parseFloat(String(value).replace(/[^\d.-]/g, ""));
  if (isNaN(amount) || amount <= 0) return null;
  return amount;
};

const formatExtraAmount = (value) => {
  const amount = parseExtraAmount(value);
  if (amount == null) return "";
  return Number.isInteger(amount) ? String(amount) : amount.toFixed(2).replace(/\.00$/, "");
};

const Villa_Magic = ({ singleProperty }) => {
  const [activeTab, setActiveTab] = useState("description");
// console.log("Single Property With Availability",singleProperty)
  const [property_id, setPropertyId] = useState("");

  const [f_name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [total_children, setChildren] = useState("");
  const [comments, setComment] = useState("");
  const [formMode, setFormMode] = useState("enquire"); // enquire | contact

  const handlePropertyIdChange=(event)=>{
    setPropertyId(event.target.value);
  }

  const [arrival_date,setArrivalDate] = useState("");
  const [departure_date,setDepartureDate] = useState("");
  const [arrivalDate2, setArrivalDate2] = useState("");
  const [departureDate2, setDepartureDate2] = useState("");


  const handleArrivalDate2Change = (e) => {
    const date = e.target.value;
    setArrivalDate2(date);
    setArrivalDate(date);
  };

  const handleDepartureDate2Change = (e) => {
    const date = e.target.value;
    setDepartureDate2(date);
    setDepartureDate(date);
  };


  const handleArrivalDateChange = (e) => {
    const date = e.target.value;
    setArrivalDate(date);
    setArrivalDate2(date);
  };

  const handleDepartureDateChange = (e) => {
    const date = e.target.value;
    setDepartureDate(date);
    setDepartureDate2(date);
  };




  const handleNameChange=(event)=>{
    setName(event.target.value);
  }

  const handleEmailChange=(event)=>{
    setEmail(event.target.value);
  }


  const handlePhoneChange=(event)=>{
    setPhone(event.target.value);
  }
  const handleChildrenChange=(event)=>{
    setChildren(event.target.value);
  }
  const handleCommentsChange=(event)=>{
    setComment(event.target.value);
  }


  // const [arrivalDate_2, setArrivalDate_2] = useState("");
  // const [departureDate_2, setDepartureDate_2] = useState("");

  const [loading, setLoading] = useState(false);

  // const [formSubmitted, setFormSubmitted] = useState(false);

  const [errors,setErrors] = useState("");

  const [message, setMessage] = useState(false);

  const recaptchaRef = useRef(null);
  const [recaptchaToken, setRecaptchaToken] = useState("");
  const handleRecaptchaChange = (token) => {
    setRecaptchaToken(token);
  };

  const propertyCurrencySymbol = useMemo(
    () => getPropertyCurrencySymbol(singleProperty),
    [singleProperty]
  );

  const optionalExtras = useMemo(() => {
    const extras = (singleProperty?.members?.extra_charges || [])
      .filter((charges) => parseExtraAmount(charges.price) != null)
      .map((charges, index) => ({
        key: `charge-${charges.id ?? index}`,
        name: charges.extra_price?.name || "Unnamed Extra",
        price: formatExtraAmount(charges.price),
        currency: getCurrencySymbol(charges.currency || propertyCurrencySymbol),
      }));

    const extraNames = new Set(extras.map((extra) => extra.name.toLowerCase()));

    if (parseExtraAmount(singleProperty?.air_con_price) != null && !extraNames.has("air-conditioning per week")) {
      extras.push({
        key: "air-con",
        name: "Air-Conditioning Per Week",
        price: formatExtraAmount(singleProperty.air_con_price),
        currency: propertyCurrencySymbol,
      });
    }

    if (parseExtraAmount(singleProperty?.pool_heating_price) != null && !extraNames.has("pool heating per week")) {
      extras.push({
        key: "pool-heating",
        name: "Pool Heating Per Week",
        price: formatExtraAmount(singleProperty.pool_heating_price),
        currency: propertyCurrencySymbol,
      });
    }

    return extras;
  }, [singleProperty, propertyCurrencySymbol]);




  const totalPriceText = useMemo(() => {
    if (!arrivalDate2 || !departureDate2 || !singleProperty?.property_prices?.length) {
      return "Add dates for prices";
    }

    const arrival = new Date(arrivalDate2);
    const departure = new Date(departureDate2);

    const nights = differenceInDays(departure, arrival);
    if (nights <= 0) return <span style={{ color: 'red' }}>Departure date must be after arrival date</span>;


    const isUnavailable = singleProperty?.availability?.some(block => {
      if (block.status !== 0) return false;
      const blockStart = new Date(block.start_date);
      const blockEnd = new Date(block.end_date);
      return arrival <= blockEnd && departure >= blockStart;
    });

    if (isUnavailable) {
      return <span style={{ color: 'red' }}>No property available for selected dates</span>;
    }


    const matchedPrice = singleProperty.property_prices.find(price => {
      const start = new Date(price.start_date);
      const end = new Date(price.end_date);
      return arrival >= start && departure <= end;
    });

    if (matchedPrice) {
      const rawPrice = parseFloat((matchedPrice.price || matchedPrice.amount || 0).toString().replace(/[^\d.-]/g, ''));
      const pricePerNight = rawPrice / 7;
      const total = (pricePerNight * nights).toFixed(2);

      const symbol = getCurrencySymbol(matchedPrice.currency) || propertyCurrencySymbol;
      return `Total (${nights} Night${nights > 1 ? 's' : ''}) - ${symbol}${Math.round(total)}`;
    }

    return <span style={{ color: 'red' }}>No property available for selected dates</span>;
  }, [arrivalDate2, departureDate2, singleProperty, propertyCurrencySymbol]);

  // console.log("Recaptcha Token",recaptchaToken);
  const eunquireSubmition = (e) =>{
    e.preventDefault();
    setLoading(true);

    const formData = {
      property_id: singleProperty.property_number,
      arrival_date,
      departure_date,
      f_name,
      phone,
      email,
      total_children,
      comments,
      recaptcha: recaptchaToken,
      form_type: formMode,
    }

    // console.log("Submitted Data",formData);

    axios.post(BASE.BASE_API_URL+"/api/enquire",formData).then((res)=>{
      // console.log("Successfully Called Api Call.");
      setMessage(res.data.message);
      setArrivalDate('')
      setDepartureDate('')
      setName('')
      setPhone('')
      setEmail('')
      setChildren('')
      setComment('')
      setErrors("");

      setLoading(false);
      // setFormSubmitted(true);
    }).catch(error => {
      if (error.response && error.response.status === 422) {
        const fieldErrors = error.response.data.errors;
        setErrors({
          property_id: fieldErrors.property_id?.[0] || '',
          arrival_date: fieldErrors.arrival_date?.[0] || '',
          departure_date: fieldErrors.departure_date?.[0] || '',
          f_name: fieldErrors.f_name?.[0] || '',
          email: fieldErrors.email?.[0] || '',
          phone: fieldErrors.phone?.[0] || '',
          total_children: fieldErrors.total_children?.[0] || '',
          comments: fieldErrors.comments?.[0] || '',
          recaptcha: fieldErrors.recaptcha?.[0] || '',
        });
      }
    }).finally(() => {
      setLoading(false);

    });


  }


  const [events, setEvents] = useState([]);

  const { id: propertyId } = useParams();
  useEffect(() => {
    const today = new Date();
    const start = format(today, "yyyy-MM-dd");
    // Fetch 24 months so "Next Year" months also have colored availability
    const end = format(addMonths(today, 24), "yyyy-MM-dd");

    axios
        .get(`${BASE.BASE_API_URL}/api/property-availability`, {
          params: {
            property_id: propertyId,
            start,
            end,
          },
        })
        .then((res) => {
          const fetchedEvents = res.data.events.map((event) => ({
            ...event,
          }));
          // console.log("Fetched events:", fetchedEvents);
          setEvents(fetchedEvents);
        })
        .catch((err) => console.error("Fetch error:", err));
  }, [propertyId]);

  // console.log("EVENTS",events);
  // console.log("Single prop",singleProperty);

  return (
    <div className="container">
      <div className="Villa_Magic_Page">

        <h1>{singleProperty.property_name_2}</h1>
        <div className='row'>
          <div className='col-md-12'>
            <div className="property-details">
              <h3>{singleProperty.resorts?.title}, Algarve</h3>
              <div className="details">
                <span> {singleProperty.sleeps_number} <FaUsers /> <span className="hide_for_mobile">Guests</span></span>
                <span> {singleProperty.bedroom} <FaBed /> <span className="hide_for_mobile">Bedrooms</span></span>
                <span> {singleProperty.bathrooms} <FaBath /> <span className="hide_for_mobile">Bathrooms</span></span>
                <span><strong>Ref</strong><span> {singleProperty.property_number} </span></span>
              </div>
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-md-7'>
            <div className="property-container">

              <div className="tabs">
                {["description", "rooms", "availability", "pricing"].map((tab) => (
                  <button
                    key={tab}
                    className={`tab ${activeTab === tab ? "active" : ""}`}
                    onClick={() => setActiveTab(tab)}
                  >
                    {tab.charAt(0).toUpperCase() + tab.slice(1)}
                  </button>
                ))}
              </div>


              <div className="tab-content">
                {activeTab === "description" && (
                  <div>
                    <h3>Description</h3>

                    {stripHTMLTags(singleProperty.description)
                        .replace(/&nbsp;/g, ' ')
                        .replace(/&euro;/g, '€')
                        .replace(/&rsquo;/g, "'")
                        .split('\n')
                        .map((line, index) => (
                            <p key={index}>
                              {line}
                              <br/>
                            </p>
                        ))
                    }

                    <h3 className="Villa_Amenities">Villa Amenities</h3>
                    <div className="amenities">
                      <h5>INDOOR</h5>
                      {
                        singleProperty.generals?.map((generals,index)=>(
                            <span><b style={{ color: "#F36722" }}>✔</b> {generals.name}</span>
                        ))
                      }
                      {
                        singleProperty.entertainments?.map((entertainment,index)=>(
                            <span><b style={{ color: "#F36722" }}>✔</b> {entertainment.name}</span>
                        ))
                      }

                      <div className="border_bottom"></div>
                      <h5>OUTSIDE</h5>
                      {
                        singleProperty.amenity?.map((amenity,index) =>(
                            <span><b style={{ color: "#F36722" }}>✔</b> {amenity.name}</span>
                        ))
                      }

                      <div className="border_bottom"></div>
                      <h5>KITCHEN</h5>
                      {
                        singleProperty.kitchens?.map((kitchen,index) =>(
                            <span><b style={{ color: "#F36722" }}>✔</b> {kitchen.name}</span>
                        ))
                      }
                    </div>
                  </div>
                )}

                {activeTab === "rooms" && <div><h3>Villa Bedrooms and Bathrooms</h3>

                    {singleProperty.bedrooms_description &&
                        Array.from({ length: 10 }, (_, i) => {
                          const bedroomNum = i + 1;
                          const typeKey = `bedroom_${bedroomNum}_type`;
                          const ensuiteKey = `bedroom_${bedroomNum}_ensuite`;
                          const type = singleProperty.bedrooms_description[typeKey];
                          const ensuite = singleProperty.bedrooms_description[ensuiteKey];

                          if (!type) return null;

                          return (
                              <div key={bedroomNum} className="amenities">

                                <h5>{`Bedroom ${bedroomNum}`}</h5>
                                <span>
                                  <b style={{ color: "#F36722" }}>✔</b>{" "}
                                  {
                                    type == "1" ? "Twin Bed" : type == "2" ? "Single Bed" : type == "3" ? "Double Bed" : type == "4" ? "Bunk Bed" : type == "5" ? "Sofa Bed" : ""
                                  }
                                </span>
                                {
                                  (ensuite == "1" || ensuite === 1) && (
                                    <span>
                                         <b style={{ color: "#F36722" }}>✔</b> En-Suite Bathroom
                                    </span>
                                )}

                                <div className="border_bottom"></div>
                              </div>
                          );
                        })}
                </div>}
                {activeTab === "availability" && <div><h3>Villa Availability</h3>
                  <div className="villa_availability">
                    <select>
                    <option>Season 2023 / 2024</option>
                    <option>Season 2024 / 2025</option>
                   <option>Season 2025 / 2026</option>
                     <option>Season 2026 / 2027</option>
                    </select>
                    <Calendar events={events} />
                  </div>
                </div>}
                {activeTab === "pricing" && <div><h3 className="seasonal_pricing">Seasonal Pricing (Weekly)</h3>
                  <div className="villa_pricing">
                      {
                        singleProperty.property_prices?.map((prices,index) =>(
                            <div className="row mt-2">
                            <div className="col-md-9 col-lg-9 col-sm-9 col-9">
                              <p>{prices.start_date}  -  {prices.end_date}</p>
                            </div>
                        <div className="col-md-3 col-lg-3 col-sm-3 col-3">
                        <p className="price">{getCurrencySymbol(prices.currency || propertyCurrencySymbol)} {prices.price}</p>
                        </div>
                              <div className="border_bottom_line"></div>
                        </div>
                        ))
                      }

                    {/*<div className="border_bottom_line"></div>*/}
                    <h3 className="mt-5 seasonal_pricing">Optional Extras</h3>

                    {
                      optionalExtras.map((extra) => (
                          <div className="row mt-2" key={extra.key}>
                            <div className="col-9">
                              <p>{extra.name}</p>
                            </div>
                            <div className="col-3">
                              <p className="price">{extra.currency || propertyCurrencySymbol} {extra.price}</p>
                            </div>
                            <div className="border_bottom_line"></div>
                          </div>
                      ))
                    }
                  </div>
                </div>}
              </div>
            </div>
          </div>
          <div className='col-md-5'>
            <form>
              <h3>Book this Villa</h3>
              <p className="filtered-prices">{totalPriceText}</p>
              <div className="row">
                <div className="col">
                  <label htmlFor="html">Arrival Date</label>
                  <input onClick={(e) => e.currentTarget.showPicker()} className="form-control" type="date" onChange={handleArrivalDate2Change} name="arrival_date"/>
                </div>
                <div className="col">
                  <label htmlFor="html">Departure Date</label>
                  <input onChange={handleDepartureDate2Change} onClick={(e) => e.currentTarget.showPicker() } className="form-control" type="date" name="departure_date"/>
                </div>
              </div>
              <div className="row">
                <div className="col"><label htmlFor="html">Bedrooms </label><input onClick={(e) => e.currentTarget.showPicker() }className="form-control"
                                                                                   value={singleProperty.bedroom} type="text"
                                                                                   name="bedrooms"/></div>
                <div className="col"><label htmlFor="html">Guests</label><input className="form-control"
                                                                                placeholder="10" value={singleProperty.sleeps_number} type="text"
                                                                                name="guests"/></div>
              </div>
              <div className="row">
                <div className="col">
                  {/*<button>Enquire</button>*/}
                  <button
                    type="button"
                    className=""
                    data-bs-toggle="modal"
                    data-bs-target="#enquiryModal"
                    onClick={() => {
                      setFormMode("enquire");
                      setMessage("");
                    }}
                  >
                    Book Now
                  </button>

                </div>
              </div>
              <div className="row">
                <div className="col">
                  <button
                    type="button"
                    className="contact_us"
                    data-bs-toggle="modal"
                    data-bs-target="#enquiryModal"
                    onClick={() => {
                      setFormMode("contact");
                      setMessage("");
                    }}
                  >
                    Contact us
                  </button>
                </div>
              </div>
            </form>

            <div className="modal fade" id="enquiryModal" tabIndex="-1" aria-labelledby="enquiryModalLabel"
                 aria-hidden="true">
              <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content modal-div">
                  <div className="modal-header">
                    <h4 className="modal-title w-100 fw-bold text-center search-page-prices">
                      {
                        formMode === "contact" ? (
                          <p className="filtered-prices">Contact Us</p>
                        ) : arrival_date && departure_date ? (
                            <p className="filtered-prices">{totalPriceText}</p>
                            ):(
                      (() => {
                        const prices = singleProperty.property_prices?.map(p => parseFloat((p.price || p.amount).toString().replace(/[^\d.-]/g, '')))
                        const symbol = propertyCurrencySymbol;
                        return prices && prices.length
                            ? `${symbol}${Math.min(...prices)} - ${symbol}${Math.max(...prices)}`
                            : "Price not available";
                      })()
                        )
                    }


                    </h4>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>



                  <div className="modal-body">
                    <form className="enquire-form" onSubmit={eunquireSubmition}>
                      <div className="">
                        <label className="form-label">Property Id</label>
                        <input type="text" onChange={handlePropertyIdChange} className="form-control enquire-input" value={singleProperty.property_number} readOnly/>
                        {errors.property_id && <span style={{ color: 'red' }}>{errors.property_id}</span>}
                      </div>

                      <div className="row">
                        <div className="col-md-6 ">
                          <label className="form-label">Arrival Date</label>
                          <input value={arrival_date} onClick={(e) => e.currentTarget.showPicker() } onChange={handleArrivalDateChange} type="date" className="form-control enquire-input" />
                          {errors.arrival_date && <span style={{ color: 'red' }}>{errors.arrival_date}</span>}
                        </div>
                        <div className="col-md-6 ">
                          <label className="form-label">Departure Date</label>
                          <input value={departure_date} onClick={(e) => e.currentTarget.showPicker() } onChange={handleDepartureDateChange} type="date" className="form-control enquire-input"/>
                          {errors.departure_date && <span style={{ color: 'red' }}>{errors.departure_date}</span>}
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6 ">
                          <label className="form-label">Name *</label>
                          <input value={f_name} type="text" onChange={handleNameChange} className="form-control enquire-input" />
                          {errors.f_name && <span style={{ color: 'red' }}>{errors.f_name}</span>}
                        </div>
                        <div className="col-md-6 ">
                          <label className="form-label">Email *</label>
                          <input value={email} onChange={handleEmailChange} type="email" className="form-control enquire-input" />
                          {errors.email && <span style={{ color: 'red' }}>{errors.email}</span>}
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6 ">
                          <label className="form-label">Phone Number</label>
                          <input value={phone} type="text" onChange={handlePhoneChange} className="form-control enquire-input"/>
                          {errors.phone && <span style={{ color: 'red' }}>{errors.phone}</span>}
                        </div>
                        <div className="col-md-6 ">
                          <label className="form-label">Number of People</label>
                          <input value={total_children} type="text" onChange={handleChildrenChange} className="form-control enquire-input"/>
                          {errors.total_children && <span style={{ color: 'red' }}>{errors.total_children}</span>}
                        </div>
                      </div>

                      <div className="">
                        <label className="form-label">Comments</label>
                        <textarea value={comments} onChange={handleCommentsChange} className="form-control enquire-input" maxLength="500" rows="3"></textarea>
                        {errors.comments && <span style={{ color: 'red' }}>{errors.comments}</span>}
                        {/*<small>(Maximum 500 Characters)</small>*/}
                      </div>

                      <div className="form-check ">
                        <input className="form-check-input" type="checkbox" id="subscribe"/>
                        <label className="form-label-subscribe" htmlFor="subscribe">
                          Send me email updates with news, special offers, discounts and promotions
                        </label>
                      </div>

                      <div className="g-recaptcha-div">
                        <div className="g-recaptcha">
                          <ReCAPTCHA
                              ref={recaptchaRef}
                              sitekey={BASE.REACT_APP_RECAPTCHA_SITE}
                              onChange={handleRecaptchaChange}
                          />
                          {errors.recaptcha && <span style={{ color: 'red' }}>{errors.recaptcha}</span>}
                        </div>
                      </div>

                      <div className="d-flex justify-content-between">

                        <button
                            type="submit"
                            className="btn  btn-primary w-50 me-2"
                            disabled={loading}
                        >
                          {loading ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Sending...
                              </>
                          ) : (
                              "Send"
                          )}
                        </button>

                        <button type="reset" className="btn btn-secondary w-50">Reset</button>
                      </div>
                      <p className="text-center mt-3 text-muted small">
                        {formMode === "contact"
                          ? "Send us a message about this property"
                          : "You won't be charged yet"}
                      </p>
                      <p className={`submition-message ${message ? "active-message" : ""}`}>
                        {message}
                      </p>
                    </form>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default Villa_Magic;